<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';
	import CourseCard from '../Course/CourseCard.svelte';

	export let titleTolgeeKey: string = 'These courses could also interest you';
	export let titleCentered: boolean = false;
	export let elementId: string = '';
	export let cards:
		| Array<{
				name: string | null;
				slug: string | null;
				thumbnail: { url: string | null | undefined };
		  }>
		| undefined
		| null;

	const { t } = getTranslate();
</script>

<div id={elementId} class="mb-36">
	{#if cards && cards.length > 0}
		<div class="col-start-1 text-4xl font-bold uppercase {titleCentered ? 'text-center' : ''}">
			{$t(titleTolgeeKey)}
		</div>
		<div class="grid col-start-1 col-end-12 mt-8">
			<div class="row-start-1 cols-start-1 cols-end-4">
				{#each cards as card}
					<CourseCard title={card.name} href={card.slug} imageData={card.thumbnail} />
				{/each}
			</div>
		</div>
	{/if}
</div>
